import { BROWSER_STORAGE_KEYS } from "utils/constants"
import { trackingService } from "utils/tracking"
import { TrackingEvents } from "utils/tracking/events"
import { ValueOf } from "utils/types"
import { UserPreferenceManager } from "utils/userPreferenceManager"

import { SpnyTourEnum } from "./Context"

export type TourKey = ValueOf<typeof BROWSER_STORAGE_KEYS>

const eventKeyMap = {
  [BROWSER_STORAGE_KEYS.spnyPlatformIntro]: "suraasa_plus",
  [BROWSER_STORAGE_KEYS.spnyCpatDashboardTour]: "cpat",
  [BROWSER_STORAGE_KEYS.cpatOnboardingQuestionnaireStatus]:
    "cpat_questionnaire",
  [BROWSER_STORAGE_KEYS.cpatTour]: "cpat_assessment_tour",
  [BROWSER_STORAGE_KEYS.spnyMasterclass]: "masterclass",
  [BROWSER_STORAGE_KEYS.spnyAiTools]: "ai_tools",
  [BROWSER_STORAGE_KEYS.spnyImpactCourse]: "impact_course",
  [BROWSER_STORAGE_KEYS.spnyJobs]: "jobs",
}

class TourManager {
  initiated(tourKey: TourKey, skipTracking?: boolean): void {
    // Update storage
    UserPreferenceManager.set(
      BROWSER_STORAGE_KEYS[tourKey],
      SpnyTourEnum.initiated
    )
    // Track event
    if (!skipTracking) {
      trackingService.trackEvent(
        TrackingEvents.spnyOnboardingTourStatus,
        {
          type: eventKeyMap[tourKey],
          status: SpnyTourEnum.initiated,
        },
        { services: ["PostHog"] }
      )
    }
  }

  completed(tourKey: TourKey, skipTracking?: boolean): void {
    // Update storage
    UserPreferenceManager.set(
      BROWSER_STORAGE_KEYS[tourKey],
      SpnyTourEnum.completed
    )

    // // Track event
    if (!skipTracking) {
      trackingService.trackEvent(
        TrackingEvents.spnyOnboardingTourStatus,
        {
          type: eventKeyMap[tourKey],
          status: SpnyTourEnum.completed,
        },
        { services: ["PostHog"] }
      )
    }
  }
}

export const tourManager = new TourManager()
